




































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {Company} from '@/models/Company';
import {UfLookup} from '@/enums/Uf';

const AuthStore = namespace('AuthStore');

@Component({
    name: 'DestinoSimples',
})
export default class DestinoSimples extends Vue {

    @AuthStore.State
    public currentCompany!: Company;

    @Prop()
    public destino: any;

    public renderCidade(cidade): string {
        if (!cidade || !cidade.id) {
            return 'Não Informada';
        }
        return cidade.nome + ' - ' + UfLookup.getUfByCod(cidade.codUf).toString();
    }

    public renderNatureza(full): string {
        return full && full.naturezaDescricao ? full.naturezaDescricao : '-';
    }

    public renderFormaPagamento = ( data ) => {
        switch (data) {
            case '0':
                return 'À Vista';
            case '1':
                return 'A Pagar';
            default:
                return 'Não Definido';
        }
    }

    public renderTipoFrete = ( data ) => {
        switch (data) {
            case '0':
                return 'Pago';
            case '1':
                return 'A Pagar';
            case '2':
                return 'Cortesia';
            default:
                return 'Não Definido';
        }
    }

    public renderDec2(val) {
        if (!val) {
            return '0,00';
        }
        return Number(val).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }

}
